import { render, staticRenderFns } from "./DashboardFilterGeneral.vue?vue&type=template&id=c70117a8"
import script from "./DashboardFilterGeneral.vue?vue&type=script&lang=js"
export * from "./DashboardFilterGeneral.vue?vue&type=script&lang=js"
import style0 from "./DashboardFilterGeneral.vue?vue&type=style&index=0&id=c70117a8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports